const splitTextBySelection = (text: string, selectionStart: number) => {
  const textBeforeSelection = text.slice(0, selectionStart)

  return textBeforeSelection
}

export default splitTextBySelection
